import { WEDDING_TEXTS_GENERATED } from '../../action-types/ui/weddingTextGenerated';

export const STATE_KEY = 'setWeddingTextStatus';

export const setWeddingTextStatus = (state = false, action) => {
  switch (action.type) {
    case WEDDING_TEXTS_GENERATED:
      return action.status;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/weddingTextGenerated.js